/**
 * Refund payment request DTO
 */
export class RefundPaymentRequestDto {
	/**
	 * The ID of the payment to refund.
	 */
	paymentId!: number;
}
